export const TABLE_ID_PATTERN = /^table_[A-Za-z0-9-]{1,64}$/;

const createTableId = (usedIds) => {
  let tableId = '';
  do {
    const randomPart =
      window.crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const safePart = String(randomPart)
      .replace(/[^A-Za-z0-9-]/g, '')
      .slice(0, 64);
    tableId = `table_${safePart || Date.now()}`;
  } while (usedIds.has(tableId));
  return tableId;
};

export const ensureStableTableIds = (tables) => {
  const usedIds = new Set();
  return (Array.isArray(tables) ? tables : []).map((candidate) => {
    const table =
      candidate && typeof candidate === 'object' ? candidate : {};
    let tableId = table.id;
    if (!TABLE_ID_PATTERN.test(tableId || '') || usedIds.has(tableId)) {
      tableId = createTableId(usedIds);
    }
    usedIds.add(tableId);
    return { ...table, id: tableId };
  });
};

export const getAnchoredTableIds = (content, tables) => {
  if (typeof content !== 'string' || !content) return new Set();
  const tableIds = new Set(
    (Array.isArray(tables) ? tables : [])
      .map((table) => table?.id)
      .filter((tableId) => TABLE_ID_PATTERN.test(tableId || ''))
  );
  if (!tableIds.size) return new Set();

  const template = document.createElement('template');
  template.innerHTML = content;
  const anchoredIds = new Set();
  template.content
    .querySelectorAll('[data-book-table-id]')
    .forEach((element) => {
      const tableId = element.getAttribute('data-book-table-id');
      if (
        element.tagName === 'DIV' &&
        element.attributes.length === 1 &&
        element.childNodes.length === 0 &&
        TABLE_ID_PATTERN.test(tableId || '') &&
        tableIds.has(tableId)
      ) {
        anchoredIds.add(tableId);
      }
    });
  return anchoredIds;
};

export const canonicalTableAnchor = (tableId) =>
  TABLE_ID_PATTERN.test(tableId || '')
    ? `<div data-book-table-id="${tableId}"></div>`
    : '';

export const removeTableAnchor = (content, tableId) => {
  if (
    typeof content !== 'string' ||
    !TABLE_ID_PATTERN.test(tableId || '')
  ) {
    return content;
  }

  const template = document.createElement('template');
  template.innerHTML = content;
  template.content
    .querySelectorAll('[data-book-table-id]')
    .forEach((element) => {
      if (element.getAttribute('data-book-table-id') === tableId) {
        element.remove();
      }
    });
  return template.innerHTML;
};
